// New UI_REVAMP
import { Box, Flex, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import BetDetailsCard from '../components/bet-result/BetDetailsCard';
import { BetResultImage } from '../components/bet-result/BetResultImage';
import BetResultList from '../components/bet-result/BetResultList';
import { BetStatus } from '../components/bet-result/BetStatus';
import GradientBox from '../components/box/GradientBox';
import FooterInfo from '../components/Footer/FooterInfo';
import { useBettingScreen } from '../hooks/useStore';

export const BetResultScreen = () => {
	const results = useBettingScreen((state) => state.results);
	const navigate = useNavigate();

	const hasFailedBet = results?.betting?.some((bet) => bet.isFail);
	const statusVal = hasFailedBet ? 'failed' : results?.status?.toLowerCase() || 'success';
	const isSuccess = statusVal === 'success';

	return (
		<Flex w='full' flex='1' minH='0' flexDirection='column' gap={4}>
			<Flex
				bgColor='linear-gradient(180deg, #FFF 0%, #E5EDF9 100%), #D6E7FF)'
				p={4}
				gap={6}
				w='full'
				flex='1'
				minH='0'
				border='1px solid #D6E7FF'
				justifyContent='space-between'
				alignItems='center'
				boxShadow='0 0 10px 0 rgba(0, 49, 152, 0.20)'
				borderRadius='16px'
				display={{ base: 'none', lg: 'flex' }}
			>
				<BetStatus
					status={isSuccess ? 'success' : 'failed'}
					amount={isSuccess ? results?.totalSuccessPrice : undefined}
					onClick={() => {
						if (isSuccess) {
							sessionStorage.setItem('accessTicketId', results?.ticketId);
							navigate('/history/ticketdetail');
						} else {
							navigate('/');
						}
					}}
					buttonText={isSuccess ? 'View Ticket' : 'Back to Home'}
				/>

				<Box
					borderRadius='16px'
					boxShadow='0px 0px 10px 0px #00319833'
					bg='white'
					w='100%'
					h='full'
					overflow='hidden'
				>
					<Flex
						flexDirection='column'
						gap={6}
						w='full'
						h='full'
						bg='white'
						p={4}
						borderRadius='16px'
						overflowY='auto'
					>
						<GradientBox borderRadius={8} mt={4} mx={3}>
							<BetDetailsCard
								data={results}
								downloadId='bet-result-ticket'
								bgGradient='linear-gradient(180deg, #FFF 0%, #E5EDF9 100%), #D6E7FF'
								mb={0}
								borderRadius='inherit'
							/>
						</GradientBox>

						<VStack spacing={4} align='stretch'>
							<BetResultList results={results} mx={3} mb={4} noGradient={true} />
						</VStack>
					</Flex>

					<BetResultImage results={results} />
				</Box>
			</Flex>
			<FooterInfo />
		</Flex>
	);
};
